const isFF = typeof navigator === 'object' && /Firefox/i.test(navigator.userAgent);
export default isFF;
